import React from 'react';
import { Sparkles } from 'lucide-react';
import { useLaunchMode } from '../hooks/useLaunchMode';

// Banner informativo mostrato SOLO quando la modalità lancio è attiva.
// Spiega che durante il lancio è tutto gratuito, ma indica chiaramente il
// modello di business standard (8% + Premium) che entrerà in vigore dopo.
export const LaunchPricingNotice = ({ className = '' }) => {
  const launchMode = useLaunchMode();
  if (!launchMode) return null;

  return (
    <div
      className={`rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 p-5 md:p-6 ${className}`}
      data-testid="launch-pricing-notice"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
          <Sparkles className="w-5 h-5 text-amber-600" />
        </div>
        <div className="text-sm md:text-base text-amber-900">
          <p className="font-bold mb-1">Fase di lancio: per ora è tutto gratuito 🎉</p>
          <p className="text-amber-800">
            Durante il lancio Rarifex <strong>azzera la commissione dell&apos;8%</strong> e include{' '}
            <strong>gratuitamente tutti i vantaggi Premium</strong>. Paghi solo il costo vivo della
            transazione (commissioni di pagamento Stripe).
          </p>
          <p className="text-amber-800 mt-2">
            Al termine della fase di lancio entrerà in vigore il modello standard descritto qui:{' '}
            <strong>8% sul venduto</strong> (tutto incluso) e abbonamento{' '}
            <strong>Premium facoltativo a €10/mese</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LaunchPricingNotice;
